import { render } from "./DSLRulesComposer.vue?vue&type=template&id=c22d941e"
import script from "./DSLRulesComposer.vue?vue&type=script&lang=js"
export * from "./DSLRulesComposer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__